module.exports = __webpack_public_path__ + "static/img/10.ebd92e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/8/zh/10.png
// module id = NDNe
// module chunks = 0